import { render, staticRenderFns } from "./stubPage.vue?vue&type=template&id=354c0c30&scoped=true&"
import script from "./stubPage.vue?vue&type=script&lang=js&"
export * from "./stubPage.vue?vue&type=script&lang=js&"
import style0 from "./stubPage.vue?vue&type=style&index=0&id=354c0c30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c0c30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354c0c30')) {
      api.createRecord('354c0c30', component.options)
    } else {
      api.reload('354c0c30', component.options)
    }
    module.hot.accept("./stubPage.vue?vue&type=template&id=354c0c30&scoped=true&", function () {
      api.rerender('354c0c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/stubs/stubPage.vue"
export default component.exports